import logo from "../assets/bunda.jpeg";
import { Link } from "react-router-dom";

export default function Header() {
  return (
    <header className="font-serif bg-white flex flex-col md:flex-row md:justify-around md:items-center px-4 md:px-20 py-3 md:py-4 gap-2 md:gap-0 shadow-sm">
      {/* Logo and text */}
      <Link to="/" className="flex items-center gap-3 self-center md:self-auto">
        <img
          src={logo}
          alt="Bunda Investment logo"
          className="h-14 w-14 sm:h-16 sm:w-16 md:h-16 md:w-16 object-contain rounded-full"
        />
        <div>
          <h1 className="text-lg sm:text-xl md:text-2xl font-bold text-amber-500 leading-tight">
            Bunda Investment
          </h1>
          <p className="text-xs sm:text-sm md:text-base italic text-gray-950 -mt-1">
            your genuine finance partner
          </p>
        </div>
      </Link>

      {/* Call & Button Section */}
      <div className="flex flex-col sm:flex-row items-center justify-center gap-2 sm:gap-4">
        <p className="text-sm lg:text-base font-semibold text-center">
          Call: 0740000077 / 0108555888
        </p>
        <Link
          to="/apply-loan"
          className="bg-amber-500 text-white text-xs sm:text-sm font-semibold px-4 py-3 rounded hover:opacity-90 whitespace-nowrap"
        >
          APPLY FOR A LOAN
        </Link>
      </div>
    </header>
  );
}
